// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AGehq","title":"styles_title__1-wLT"};